// extracted by mini-css-extract-plugin
export default {"selectedVideo":"selected-video_selectedVideo__+e2XN","videoMenu":"selected-video_videoMenu__9myKg"};